import React from 'react';
import PropTypes from 'prop-types';

import { useTheme } from '../../ThemeContext';

import { Label } from './HeaderLabel.style';

const HeaderLabel = ({ children }) => {
  const theme = useTheme();

  return <Label theme={theme.headerLabel.label}>{children}</Label>;
};

HeaderLabel.propTypes = {
  children: PropTypes.node,
};

export default HeaderLabel;
